<template>
  <div class="passenger-transactions">
    <br />
    <h1 style="text-align: center;">Passenger Transactions</h1>
    <div class="layout justify-end pr-3 pl-3">
      <v-btn v-if="isAdmin && !isOnlyInvestor" @click="openUnusedBalanceRefundDialog" small>
        <v-icon small left>fal fa-recycle</v-icon>
        Create Ticket Refund
      </v-btn>
      <v-btn v-if="isAdmin && !isOnlyInvestor" @click="createAgentCreditRefundDialog = true" small>
        <v-icon small left>fal fa-undo</v-icon>
        Refund Agent Credit
      </v-btn>
    </div>
    <form @submit.prevent="submitSearch">
      <v-layout row wrap>
<!--        <v-flex v-show="selectedVendor !== 'mtnghana'" sm3 pa-2>-->
<!--          <v-text-field-->
<!--              solo-->
<!--              v-model="searchKeywords"-->
<!--              append-icon="fal fa-search"-->
<!--              :rules="[v => !v || v.length >= 2 || 'Min 2 characters']"-->
<!--              :disabled="apiInProgress"-->
<!--              type="search"-->
<!--              placeholder="Search by email or name"-->
<!--              @keyup.enter="searchTransactions"-->
<!--              @click:append="searchTransactions"-->
<!--          />-->
<!--        </v-flex>-->
        <v-flex sm4 pa-2>
          <v-text-field
              solo
              clearable
              v-model="searchPhone"
              append-icon="fal fa-search"
              :rules="[v => !v || (/[\s\d-()+]+/.test(v) && v.length >= 2) || 'Please provide only numbers or \'+\' (min 2 digits)']"
              :disabled="apiInProgress"
              type="search"
              placeholder="Search by phone"
              @keyup.enter="submitSearch"
              @click:append="submitSearch"
          />
        </v-flex>
        <v-flex sm3 pa-2>
          <v-select
            :items="logTypes"
            clearable
            label="Log Type"
            dense
            multiple
            single-line
            placeholder="Select Log Type(s)"
            v-model="selectedLogTypes"
          >
            <template v-slot:selection="{ item, index }">
              <small v-if="index === 0">{{ item.text }}</small>
              <small v-if="index === 1"
                class="grey--text caption pl-2"
              >(+{{ selectedLogTypes.length - 1 }} others)</small>
            </template>
          </v-select>
        </v-flex>
        <v-flex sm4>
          <v-layout>
            <v-flex xs6 pa-2>
              <st-date-field
                id="passenger-transactions-date-from"
                v-model="dateFrom"
                label="Date From"
                to-date-id="passenger-transactions-date-to"
              />
            </v-flex>
            <v-flex xs6 pa-2>
              <st-date-field
                id="passenger-transactions-date-to"
                v-model="dateTo"
                label="Date To"
                from-date-id="passenger-transactions-date-from"
              />
            </v-flex>
          </v-layout>
        </v-flex>
        <!-- <v-flex sm2 pa-2>
          <v-select
              :items="vendors"
              :clearable="!isVendor"
              label="Vendor"
              v-model="selectedVendor"
          />
        </v-flex> -->
        <v-flex sm1 pa-2>
          <v-btn small fab type="submit"><v-icon small>fal fa-filter</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </form>
    <v-data-table
        :headers="headers"
        :items="transactions"
        :pagination.sync="pagination"
        :total-items="tableTotalItems"
        :hide-actions="!isTotalTransactionsKnown"
        :loading="apiInProgress"
        :rows-per-page-items="[10, 25, 50]"
        @update:pagination="onPagination"
        class="elevation-1 passenger-transactions-table"
        must-sort
    >
      <template v-slot:items="props">
        <tr @click="viewMetadata(props.item)">
          <td v-if="isAdmin && !isOnlyInvestor" @click.stop="props.item.selected = !props.item.selected" class="layout justify-center align-center passenger-transaction-checkbox-cell">
            <v-checkbox
              v-if="props.item.logType === 'purchased_ticket' && !Boolean(props.item.logMetadata && props.item.logMetadata.unusedBalanceRefundId)"
              v-model="props.item.selected"
              @change="props.item.selected = !props.item.selected"
              class="ma-0 pa-0"
              hide-details
            />
            <v-tooltip
              top
              v-if="props.item.logType === 'purchased_ticket' && Boolean(props.item.logMetadata && props.item.logMetadata.unusedBalanceRefundId)"
            >
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">fas fa-info-circle</v-icon>
              </template>
              <span>
                This transaction is associated with ticket refund {{props.item.logMetadata.unusedBalanceRefundId}}
              </span>
            </v-tooltip>
          </td>
          <td :title="props.item.phoneLabel" class="passenger-transaction-phone-cell">
            {{props.item.phoneLabel}}
          </td>
          <!-- <td class="text-xs-right" :title="props.item.stUser && props.item.stUser.email">
            <v-text-field
              class="text-xs-right text-field--flat"
              :value="props.item.stUser ? props.item.stUser.email : ''"
              readonly
              hide-details
            />
          </td> -->
          <td>
            <div v-html="props.item.amountLabel" />
            <div v-if="props.item.logMetadata.isReservedTicket">
              <v-chip small>
                <small>Flat Rate Fare</small>
              </v-chip>
            </div>
          </td>
          <td v-html="props.item.profileBalanceBeforeLabel" />
          <td v-html="props.item.profileBalanceAfterLabel" />
          <td :title="props.item.logTypeLabel" class="passenger-transaction-type-cell">
            <div class="passenger-transaction-type-cell__content">
              <v-icon v-if="props.item.logTypeIcon" small class="passenger-transaction-type-cell__icon">{{props.item.logTypeIcon}}</v-icon>
              <v-text-field
                class="text-xs-left text-field--flat pb1"
                :value="props.item.logTypeLabel"
                readonly
                hide-details
                @click.stop
              />
            </div>
          </td>
          <td>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon small v-on="on">{{props.item.logStatusIcon}}</v-icon>
              </template>
              <span v-html="props.item.logStatusTooltip" />
            </v-tooltip>
          </td>
          <td class="passenger-transaction-date-cell">
            <small v-html="props.item.dateUpdatedLabel" />
          </td>
          <td class="passenger-transaction-date-cell">
            <small v-html="props.item.dateRecordedLabel" />
            <div v-if="props.item.logMetadata.isReservedTicket">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-chip small class="passenger-transaction-date-chip" v-on="on">
                    <v-icon small left v-if="props.item.logMetadata.transportationProfileEventId">fas fa-calendar-star</v-icon>
                    <v-icon small left v-else>fal fa-clock</v-icon>
                    <small>{{props.item.dateCreatedLabel}}</small>
                  </v-chip>
                </template>
                <span>{{props.item.logMetadata.transportationProfileEventId ? 'Event' : 'Reserved'}}</span>
              </v-tooltip>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    <div v-if="!isTotalTransactionsKnown" class="layout row justify-space-between align-center pa-3">
      <div class="layout row justify-end align-center" style="width: 100%;">
        <small class="pr-2">Page {{ Number(pagination.page) }}</small>
        <v-btn icon :disabled="!canGoToPreviousPage" @click="goToPreviousPage">
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn icon :disabled="!canGoToNextPage" @click="goToNextPage">
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </div>
    </div>
    <v-dialog
      transition="dialog-bottom-transition"
      scrollable
      persistent
      max-width="600"
      v-model="createAgentCreditRefundDialog">
      <v-card v-if="createAgentCreditRefundDialog">
        <v-card-title class="headline grey lighten-2 text-xs-center">
          Refund Agent Credit Back to Agent
        </v-card-title>
        <v-card-text>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Agent</strong>
            </v-flex>
            <v-flex sm8 pt-2 pl-2 pr-2>
              <agent-selector
                v-model="newAgentCreditRefund.agent"
                :child-props="{ placeholder: 'Search by phone number, name or email', label: 'Selected agent', outline: true }"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Passenger</strong>
            </v-flex>
            <v-flex sm8 pt-2 pl-2 pr-2>
              <passenger-selector
                v-model="newAgentCreditRefund.passengerIdentifier"
                :child-props="{ placeholder: 'Search by phone number or name', label: 'Selected passenger', outline: true }"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Amount</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              <currency-field
                v-model="newAgentCreditRefund.amount"
                :child-props="{
                  prefix: countryCurrency ? countryCurrency.currencySymbol : '',
                  placeholder: '0.00'
                }"
              />
            </v-flex>
          </v-layout>
          <v-alert v-if="selectedAgentBlocksAdminRefund" :value="true" type="warning" class="mt-3">
            Agent credit refunds are not available for this agent. The passenger can refund unused credit to their own mobile money account.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="layout justify-space-between">
          <v-btn class="warning" flat @click="createAgentCreditRefundDialog = false">
            Cancel
          </v-btn>
          <v-btn
            class="primary"
            :disabled="selectedAgentBlocksAdminRefund || !newAgentCreditRefund.agent || !newAgentCreditRefund.amount || !newAgentCreditRefund.passengerIdentifier"
            :loading="apiInProgress"
            @click="saveAgentCreditRefund({
              newAgentCreditRefund
            })"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      scrollable
      persistent
      max-width="600"
      v-model="createUnusedBalanceRefundDialog">
      <v-card v-if="createUnusedBalanceRefundDialog">
        <v-card-title class="headline grey lighten-2 text-xs-center">
          Create Ticket Refund
        </v-card-title>
        <v-card-text>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Passenger</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              {{ refundPassengerPhoneLabel || 'Unknown phone number' }}
            </v-flex>
          </v-layout>
          <v-layout row align-center>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Amount</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              <currency-field
                v-model="newUnusedBalanceRefund.amount"
                :child-props="{
                  prefix: countryCurrency ? countryCurrency.currencySymbol : '',
                  placeholder: '0.00'
                }"
              />
            </v-flex>
          </v-layout>
          <v-layout row align-top>
            <v-flex sm4 pa-2 class="text-xs-right">
              <strong>Selected Purchased Ticket(s)</strong>
            </v-flex>
            <v-flex sm8 pa-2>
              <div v-if="!selectedPurchasedTickets.length">
                No ticket(s) selected to associate with refund
              </div>
              <div v-else>
                <div class="mb-2">
                  <strong>Total: </strong>
                  <span v-html="selectedPurchasedTicketsTotalLabel" />
                </div>
                <div style="max-height: 100px; overflow-y: auto; padding-right: 10px">
                  <div
                    v-for="purchasedTicket in selectedPurchasedTickets"
                    :key="purchasedTicket.id"
                  >
                    <div class="mb-2 layout row justify-space-between align-center">
                      <div>
                        <strong>{{purchasedTicket.parsedId}}</strong>
                      </div>
                      <div>
                        <span v-html="purchasedTicket.amountLabel" />
                      </div>
                      <div>
                        <span v-html="purchasedTicket.dateCreatedLabel" />
                      </div>
                    </div>
                    <div style="border-bottom: 1px solid #ccc"></div>
                  </div>
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="layout justify-space-between">
          <v-btn class="warning" flat @click="createUnusedBalanceRefundDialog = false">
            Cancel
          </v-btn>
          <v-btn
            class="primary"
            :disabled="!selectedPurchasedTickets.length || !newUnusedBalanceRefund.passengerProfileId || !newUnusedBalanceRefund.amount"
            :loading="apiInProgress"
            @click="saveUnusedBalanceRefund({
              newUnusedBalanceRefund,
              selectedPurchasedTickets
            })"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      transition="dialog-bottom-transition"
      scrollable
      max-width="920"
      v-model="metadataLoaded">
      <v-card v-if="selectedMetadata">
        <v-card-title ref="metadataDialogTitle" class="headline grey lighten-2 text-xs-center">
          {{selectedMetadata.phoneLabel}} Transaction Metadata
        </v-card-title>
        <v-card-text>
          <v-tabs ref="metadataDialogTabs" v-if="isSelectedPurchasedTicket" v-model="metadataTab" grow>
            <v-tabs-slider color="primary" />
            <v-tab ripple href="#details">
              Ticket Details
            </v-tab>
            <v-tab ripple href="#trips">
              Trip(s)
            </v-tab>
          </v-tabs>
          <div v-show="!isSelectedPurchasedTicket || metadataTab === 'details'" style="border-top: 1px solid #ccc;" class="pt-3">
            <v-layout row wrap>
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>ID</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.parsedId"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>dateCreated</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.dateCreatedLabel"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>dateUpdated</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.dateUpdatedLabel"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>logType</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.logType"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>logStatus</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.logStatus"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="isSelectedPurchasedTicket">
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>Bus licence plate(s)</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <span v-if="transactionTripsLoading">Loading...</span>
                <span v-else>{{selectedTicketLicencePlateLabel || 'N/A'}}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="selectedMetadata.cachedTransportationProfileEvent">
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>Event details</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.cachedTransportationProfileEvent"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-if="selectedMetadata.stUserLabel">
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>User details</strong>
              </v-flex>
              <v-flex sm8 pl-1>
                <div v-html="selectedMetadata.stUserLabel"></div>
              </v-flex>
            </v-layout>
            <v-layout row wrap v-for="(value, propertyName, index) in selectedMetadata.logMetadataParsed" :key="`metadata${index}`">
              <v-flex sm4 pr-1 class="text-xs-right">
                <strong>{{ propertyName }}</strong>
              </v-flex>
              <v-flex sm8 pl-1 class="layout row flex-start">
                <div v-html="value"></div>
                <div v-if="propertyName === 'requestedByStUserId' || propertyName === 'stUserId' || propertyName === 'expiredByStUserId'">
                  <v-btn small @click="viewUser(value)"><small>View User</small></v-btn>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div v-if="isSelectedPurchasedTicket" v-show="metadataTab === 'trips'" style="border-top: 1px solid #ccc;" class="pt-3">
            <v-alert v-if="transactionTripsError" :value="true" type="error">
              {{transactionTripsError}}
            </v-alert>
            <div v-else-if="transactionTripsLoading" class="text-xs-center pa-4">
              <v-progress-circular indeterminate color="primary" />
              <div class="mt-2">Loading linked trips...</div>
            </div>
            <v-alert v-else-if="!transactionTrips.length" :value="true" type="info">
              No trips are linked to this ticket.
            </v-alert>
            <div v-else-if="selectedTrip">
              <div ref="metadataTripMapOffsetContent">
                <v-select
                  v-if="transactionTrips.length > 1"
                  :items="selectedTripOptions"
                  v-model="selectedTripId"
                  label="Select trip"
                  outline
                />
                <v-layout row wrap class="mb-3">
                  <v-flex sm6 pa-1>
                    <div class="passenger-trip-endpoint-heading">
                      <img
                        class="passenger-trip-endpoint-pin"
                        :src="tripBoardIconUrl"
                        alt=""
                        aria-hidden="true"
                      />
                      <strong>Board</strong>
                    </div>
                    <div>{{selectedTrip.originLabel || 'N/A'}}</div>
                    <small>{{selectedTrip.dateEmbarkedLabel || 'N/A'}}</small>
                  </v-flex>
                  <v-flex sm6 pa-1>
                    <div class="passenger-trip-endpoint-heading">
                      <img
                        class="passenger-trip-endpoint-pin"
                        :src="tripAlightIconUrl"
                        alt=""
                        aria-hidden="true"
                      />
                      <strong>Alight</strong>
                    </div>
                    <div>{{selectedTrip.destinationLabel || 'N/A'}}</div>
                    <small>{{selectedTrip.dateDisembarkedLabel || 'N/A'}}</small>
                  </v-flex>
                  <v-flex sm4 pa-1>
                    <strong>Bus licence plate</strong>
                    <div>{{selectedTripLicencePlate || 'N/A'}}</div>
                  </v-flex>
                  <v-flex sm4 pa-1>
                    <strong>Final fare</strong>
                    <div>{{selectedTripFareLabel}}</div>
                  </v-flex>
                  <v-flex sm4 pa-1>
                    <strong>Distance travelled</strong>
                    <div>{{selectedTripDistanceLabel}}</div>
                  </v-flex>
                </v-layout>
                <v-alert v-if="tripBusStopsLoading" :value="true" type="info">
                  Loading route bus stops...
                </v-alert>
              </div>
              <st-map
                v-if="shouldRenderTripMap"
                :key="tripMapContainerId + '-' + selectedTripId"
                disable-search
                disable-map-hash
                :height-offset="tripMapHeightOffset"
                :container-id="tripMapContainerId"
                :api="stMapApis"
                :mapbox-access-token="mapboxAccessToken"
                :maptiler-key="maptilerKey"
                :marker-options="markerOptions"
                :default-center="tripMapDefaultCenter"
                :default-zoom="12"
                :route-coordinates="selectedTripRouteCoordinates"
                :on-map-loaded="onTripMapLoaded"
              />
              <v-alert v-else :value="true" type="warning">
                Map keys are not configured for this environment.
              </v-alert>
            </div>
            <v-alert v-else :value="true" type="warning">
              Select a trip to view its map.
            </v-alert>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions ref="metadataDialogActions" class="layout justify-space-between align-center">
          <div v-if="isAdmin && selectedMetadata && selectedMetadata.logType === 'purchased_ticket' && selectedMetadata.logStatus !== 'expired' && selectedMetadata.logStatus !== 'completed'">
            <v-checkbox
              class="mt-0 pt-0"
              hide-details
              v-model="expireNowRefundUnusedBalance"
              label="Refund ticket balance"
              :disabled="apiInProgress"
            />
            <v-btn
              class="warning"
              :loading="apiInProgress"
              :disabled="apiInProgress"
              @click="expireTicketNow()"
              small
            >
              Expire now
            </v-btn>
          </div>
          <div v-else-if="canRefundPurchasedBeacon">
            <v-btn
              class="warning"
              :loading="apiInProgress"
              :disabled="apiInProgress"
              @click="confirmRefundPurchasedBeacon()"
              small
            >
              Refund purchased beacon
            </v-btn>
          </div>
          <v-btn @click="metadataLoaded = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import src from './src'
export default src
</script>

<style scoped>
.passenger-transactions-table {
  width: 100%;
}

.passenger-transactions-table /deep/ table {
  font-size: 12px;
}

.passenger-transactions-table /deep/ th,
.passenger-transactions-table /deep/ td {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.passenger-transactions-table /deep/ tbody td {
  height: 40px;
}

.passenger-transaction-checkbox-cell {
  padding-top: 8px !important;
}

.passenger-transaction-checkbox-cell /deep/ .v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}

.passenger-transaction-phone-cell {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.passenger-transaction-type-cell {
  max-width: 110px;
}

.passenger-transaction-type-cell__content {
  display: flex;
  align-items: center;
  min-width: 0;
}

.passenger-transaction-type-cell__icon {
  flex-shrink: 0;
  margin-right: 4px;
}

.passenger-transaction-type-cell /deep/ .v-input {
  flex: 1 1 auto;
  min-width: 0;
}

.passenger-transaction-date-cell {
  min-width: 112px;
  white-space: nowrap;
}

.passenger-transaction-date-chip {
  margin: 2px 0 0;
}

.passenger-trip-endpoint-heading {
  display: flex;
  align-items: center;
}

.passenger-trip-endpoint-pin {
  width: 16px;
  height: 22px;
  object-fit: contain;
  margin-right: 6px;
  flex-shrink: 0;
}
</style>
